import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import About from "./Components/About";
import Banner from "./Components/Banner";
import HowItWorks from "./Components/HowItWorks";
import Partner from "./Components/Partner";
import Roadmap from "./Components/Roadmap";
import Tokenomics from "./Components/Tokenomics";
import TokenSale from "./Components/TokenSale";
import { useGetHompagedata, useGetTokonomiesdata, useGetFaqdata, useGetpresaletimer } from "./HomepageApi";
import { useNavigate } from "react-router-dom";
import Faq from "./Components/Faq";


const Home = (props) => {
    useEffect(() => {
        AOS.init({
            disable: 'mobile'
        });
    }, []);
    const language = localStorage.getItem('Lang') || 'english';
    const { data: Homepagedata} = useGetHompagedata({

        language: language
    });

    const { data: Homepagetoken } = useGetTokonomiesdata();
    const { data: Homepagefaq } = useGetFaqdata();
    const { data: Homepagetimer } = useGetpresaletimer();

    const navigate = useNavigate()
    const buy = async () => {
        try {
            if (!sessionStorage.getItem("user_JWT")) {
                navigate('/login')
            } else {
                navigate('/buytoken')
            }

        } catch (error) {

        }
    }

    return (


        <div className="MainBg">
            <div className="CntLdDv">
                <div id="banner">
                    <Banner homepagedata={Homepagedata?.data[0]} timedata={Homepagetimer?.data[0]} buy={buy} />
                </div>

                <div id="about">
                    <About homepagedata={Homepagedata?.data[0]} />
                </div>
                <div id="partner">

                    <Partner homepagedata={Homepagedata?.data[0]} />
                </div>
                <div id="tokensale" >

                    <TokenSale homepagedata={Homepagedata?.data[0]} timedata={Homepagetimer?.data[0]} buy={buy} />
                </div>
                <Tokenomics homepagetokendata={Homepagetoken?.data} homepagedata={Homepagedata?.data[0]} buy={buy} />
                <div id="roadmap">

                    <Roadmap homepagedata={Homepagedata?.data[0]} />
                </div>
                <div id="faq">
                    <Faq homepagefaqdata={Homepagefaq?.data} homepagedata={Homepagedata?.data[0]} />
                </div>
                {/* <div id="howitworks">
                    <HowItWorks homepagedata={Homepagedata?.data[0]} />
                </div> */}
            </div>
        </div>

    );

}

export default Home;